import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [errors, setErrors] = useState()
    const [account, setAccount] = useState()
    const [plans, setPlans] = useState([])
    const [providers, setProviders] = useState({})
    const [isLoading, setIsLoading] = useState(true)


    const GetEntities = async () => {
        const requestPlans = await UsePut(
            `/plans/get`,
            {data: {offset: 0}, toArray: true, propLabel: "name"}
        )

        const requestProviders = await UsePut(
            `/providers/get`,
            {data: {offset: 0}}
        )

        const requestAccount =  await UsePut(
            `/accounts/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const smsProviders = [];
        const emailProviders = [];


        requestProviders?.entities?.length > 0 && requestProviders.entities.map((provider) => {
            if(provider?.channel === 'sms'){
                smsProviders.push({value: provider._id.$oid, label: provider.name})
            }
            if(provider?.channel === 'email'){
                emailProviders.push({value: provider._id.$oid, label: provider.name})
            }
        })

        return  {
            plans: requestPlans,
            account: requestAccount?.entities[0],
            providers: {
                sms: smsProviders,
                email: emailProviders
            },
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setPlans(response.plans)
            setAccount(response.account)
            setProviders(response.providers)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/accounts/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Account has been successfully updated')
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form
                                plans={plans}
                                errors={errors}
                                account={account}
                                isReady={!isLoading}
                                providers={providers}
                                onSubmit={handleUpdate}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit